import { render, staticRenderFns } from "./rehberBasvur.vue?vue&type=template&id=5dd9a874"
import script from "./rehberBasvur.vue?vue&type=script&lang=js"
export * from "./rehberBasvur.vue?vue&type=script&lang=js"
import style0 from "./rehberBasvur.vue?vue&type=style&index=0&id=5dd9a874&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports